export const AUTH_SESSION_KEY = 'auth_session'

export function beginAuthSession() {
  const identity = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
  localStorage.setItem(AUTH_SESSION_KEY, identity)
  return identity
}

export function currentAuthSession() {
  return localStorage.getItem(AUTH_SESSION_KEY)
}

export function ensureAuthSession() {
  return currentAuthSession() || beginAuthSession()
}
